<template>
    <div :class="clsx('big-logo', { 'animations-disabled': !animationEnabled })">
      <img class="logo" src="/images/promo/hero-section/big-logo.svg" alt="UConnect logo" />
      <slot />
    </div>
</template>

<script>
import clsx from 'clsx';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
  },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.big-logo {
    display: flex;
    justify-content: center;
    align-items: center;
}

.logo {
    width: 366px;
    height: 408px;
    animation: big-logo-animation 5s forwards;
    animation-delay: 15s;

    @media (max-width: 1300px) {
      width: 293px;
      height: 326px;
      transform-origin: center;
    }

    @media (max-width: 1050px) {
      width: 220px;
      height: 245px;
      transform-origin: center;
    }
}

.animations-disabled,
.animations-disabled * {
  animation: none !important;
  animation-duration: 0s !important;
  animation-delay: 0s !important;
  transition: none !important;
}

.animations-disabled {
  .logo {
    transform: scale(1);
  }
}

@keyframes big-logo-animation {
    0% {
        transform: scale(1);
    }
    45% {
        transform: scale(1.15);
    }
    55% {
        transform: scale(1.15);
    }
    100% {
        transform: scale(1);
    }
}
</style>
